<div class="header">
    <div class="left">
        <a href="#"><img src="/assets/images/generico/logo.png" class="logo"></a>
    </div>

    <div class="right">
        <span class="user-name" *ngIf="identity || token && false">
            {{ identity?.nombres + ' ' + identity?.apellidoP + ' ' + identity?.apellidoM }}
        </span>
        <button mat-button [matMenuTriggerFor]="menu" *ngIf="identity || token && false">
            <mat-icon class="icon" matBadgeColor="warn">person</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="openPerfil()">
                <mat-icon matBadgeColor="warn">person</mat-icon> Mi perfil
            </button>
            <button mat-menu-item (click)="logout()">
                <mat-icon>exit_to_app</mat-icon> Cerrar Sesi&oacute;n
            </button>
        </mat-menu>
        <button mat-icon-button matTooltip="Servicios" aria-label="Volver al inicio" (click)="back()">
            <mat-icon class="icon">home</mat-icon>
        </button>
    </div>
</div>

<!-- 
<div>
    <img src="/assets/images/bnr3.png" class="bnr1">
</div> -->


<body>
    <div class="container mat_step_container" *ngIf="!mostrar_solicitud">

        <mat-card class="example-card">
            <mat-card-header align="center">
                <div class="row" style="width: 100%; height: 150px;">
                    <div class="title1"> Solicitud de Certificados</div>
                </div>
            </mat-card-header>

            <mat-card-content>
                <table class="table-cert">
                    <tr class="tr-title">
                        <td>
                            <p class="table_title">Nombre certificados</p>
                        </td>
                        <td>
                            <p class="table_title">Valor</p>
                        </td>
                        <td>
                            <p class="table_title">Plazo</p>
                        </td>
                        <td>
                            <p class="table_title">Estampilla</p>
                        </td>
                    </tr>
                    <tr class="tr-info" *ngFor="let cert of valores_cert">
                        <td>
                            {{ cert.nombre }} <a (click)="verObligatorios(cert)"
                                *ngIf="cert.nombre == 'CERTIFICADO DE VIVIENDA SOCIAL' "> (ver documentos obligatorios
                                <i class="material-icons" style="font-size:1em ;">description</i>) </a>
                        </td>
                        <td>
                            ${{ cert.valor}}
                        </td>
                        <td>
                            {{ cert.plazo }} Dias {{ cert.tipoPlazo }}
                        </td>
                        <td>
                            ${{ cert.estampilla }}
                        </td>
                    </tr>
                </table>
            </mat-card-content>
            <div style="padding: 10px">
                <button class="btn_center" mat-raised-button color="primary"
                    (click)="solicitar_Certificados()">Solicitar
                    Certificados</button>
            </div>
        </mat-card>
    </div>


    <div class="container mat_step_container" *ngIf="mostrar_solicitud">
        <!--  <div class="row" align="right">
            <button class="btn_danger" mat-button (click)="cerrar_vista()">Salir</button>
        </div> -->
        <div class="container">
            <mat-horizontal-stepper class="container-stepper" #stepper>
                <mat-step [stepControl]="firstFormGroup">
                    <form [formGroup]="firstFormGroup">
                        <ng-template matStepLabel>Datos personales</ng-template>
                        <div class="row" *ngIf="!modificando">
                            <div class="col-lg-12 col-sm-12 col-xs-12 col-md-12 contbuscar" style="margin-left: 5%">
                                <p>Ingrese su rut</p>
                                <mat-form-field>
                                    <input matInput placeholder="Rut" formControlName="rut">
                                </mat-form-field>
                                <button mat-raised-button color="primary"
                                    [disabled]="!firstFormGroup.controls.rut.valid"
                                    (click)="buscar_info_sol()">Continuar</button>
                            </div>

                        </div>
                        <div class="container_info_rut" *ngIf="primerPaso">
                            <div class="row">
                                <p class="title_datos"><strong>Datos solicitante</strong></p>
                            </div>
                            <div class="container_info_rut2">
                                <div class="row" style="padding-bottom: 20px">
                                    <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                                        <p>RUT:</p>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                        {{ info_rut.rut }}
                                    </div>
                                    <div
                                        class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                                        <p>Teléfono:</p>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                        {{ info_rut.telefono }}
                                    </div>
                                    <hr class="col-lg-10 col-md-10 col-sm-10" />
                                </div>
                                <div class="row" style="padding-bottom: 20px">
                                    <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                                        <p>Solicitante:</p>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                        {{ info_rut.nombre }} {{ info_rut.apellido_p}} {{ info_rut.apellido_m}}
                                    </div>
                                    <div
                                        class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                                        <p>Celular:</p>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                        {{ info_rut.celular }}
                                    </div>
                                    <hr class="col-lg-10 col-md-10 col-sm-10" />
                                </div>
                                <div class="row" style="padding-bottom: 20px">
                                    <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                                        <p>Calle:</p>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                        {{ info_rut.calle }}
                                    </div>
                                    <div
                                        class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                                        <p>Ciudad:</p>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                        {{ info_rut.ciudad }}
                                    </div>
                                    <hr class="col-lg-10 col-md-10 col-sm-10" />
                                </div>
                                <div class="row" style="padding-bottom: 20px">
                                    <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                                        <p>Número:</p>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                        {{ info_rut.numero }}
                                    </div>
                                    <div
                                        class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                                        <p>Comuna:</p>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                        {{ info_rut.comuna }}
                                    </div>
                                    <hr class="col-lg-10 col-md-10 col-sm-10" />
                                </div>
                                <div class="row" style="padding-bottom: 20px">
                                    <div class="col-lg-2 col-md-2 col-sm-2 name_info">
                                        <p>Complemento:</p>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                        {{ info_rut.complemento }}
                                    </div>
                                    <div
                                        class="col-lg-2 col-md-2 col-sm-2 col-lg-offset-1 col-md-offset-1 col-sm-offset-1 name_info">
                                        <p>Email:</p>
                                    </div>
                                    <div class="col-lg-3 col-md-3 col-sm-3 view_info">
                                        {{ info_rut.email }}
                                    </div>
                                    <hr class="col-lg-10 col-md-10 col-sm-10" />
                                </div>
                            </div>
                            <div *ngIf="!continuar" class="col-md-12 col-sm-12 col-lg-12 col-xs-12 error-mail">
                                <p>El mail es obligatorio, favor modificar su usauario e ingresar un mail valido.</p>
                            </div>
                        </div>
                        <div formGroupName="mod_solicitante" class="container_info_rut" *ngIf="modificando">
                            <div class="row title_mod_div" *ngIf="rut_encontrado">
                                <strong>
                                    <p class="title_mod">Modificando Datos del solicitante</p>
                                </strong>
                            </div>
                            <div class="row title_mod_div" *ngIf="!rut_encontrado">
                                <strong>
                                    <p class="title_mod">Registrando Datos del solicitante</p>
                                </strong>
                            </div>
                            <div class="row" style="margin-left: 10%;">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <p class="title_info">Nombre *</p>
                                    <mat-form-field>
                                        <input matInput formControlName="nombre">
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <p class="title_info">Teléfono </p>
                                    <mat-form-field>
                                        <input matInput formControlName="telefono">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row" style="margin-left: 10%;">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <p class="title_info">Apellido Paterno</p>
                                    <mat-form-field>
                                        <input matInput formControlName="apellido_p">
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <p class="title_info">Celular *</p>
                                    <mat-form-field>
                                        <input matInput formControlName="cel">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row" style="margin-left: 10%;">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <p class="title_info">Apellido Materno</p>
                                    <mat-form-field>
                                        <input matInput formControlName="apellido_m">
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <p class="title_info">Ciudad</p>
                                    <mat-form-field>
                                        <input matInput formControlName="ciudad">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row" style="margin-left: 10%;">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <p class="title_info">Calle *</p>
                                    <mat-form-field>
                                        <input matInput formControlName="calle">
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <p class="title_info">Comuna</p>
                                    <mat-form-field>
                                        <input matInput formControlName="comuna">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row" style="margin-left: 10%;">
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <p class="title_info">Número *</p>
                                    <mat-form-field>
                                        <input matInput formControlName="num">
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-6 col-md-6 col-sm-6">
                                    <p class="title_info">Email *</p>
                                    <mat-form-field>
                                        <input matInput formControlName="email">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="row" style="margin-left: 10%;">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <p class="title_info">Complemento</p>
                                    <mat-form-field>
                                        <input matInput formControlName="complemento">
                                    </mat-form-field>
                                </div>
                            </div>

                        </div>
                        <div *ngIf="!modificando" class="row" style="padding: 0px">
                            <div class="col-lg-6 col-md-6 col-sm-6">
                                <button mat-raised-button color="primary" (click)="mod_inforut()"
                                    [disabled]="!rut_encontrado">Modificar</button>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6" align="right">
                                <button mat-raised-button color="primary" matStepperNext
                                    [disabled]="!primerPaso || !continuar || !emailValido">Continuar</button>
                            </div>
                        </div>
                        <div *ngIf="modificando" class="col-md-12" style="padding: 0px">
                            <div class="col-lg-6 col-md-6 col-sm-6" align="left" style="padding: 0px">
                                <button class="btn_danger" mat-raised-button (click)="cancelar_mod()">Cancelar</button>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6" *ngIf="rut_encontrado" align="right"
                                style="padding: 0px">
                                <button mat-raised-button color="primary" (click)="guarda_mod()">Guardar</button>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6" *ngIf="!rut_encontrado" align="right"
                                style="padding: 0px">
                                <button mat-raised-button color="primary" (click)="registro_sol()"
                                    [disabled]="!firstFormGroup.valid">Registrar</button>
                            </div>
                        </div>
                    </form>
                </mat-step>

                <mat-step [stepControl]="secondFormGroup">
                    <form [formGroup]="secondFormGroup">
                        <ng-template matStepLabel>Identificación</ng-template>
                        <div class="row">
                            <div class="col-lg-12">
                                <strong>
                                    <p class="title_datos">Ingrese las direcciones(Máximo de 3 direcciones)</p>
                                </strong>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm--12 div_rol">
                                <p>Rol</p>
                                <mat-form-field class="mat-field-calle">
                                    <input class="mat_input" matInput placeholder="(ej: 279-10)" [formControl]="rol">
                                    <button mat-button style="margin: 0px;" *ngIf="secondFormGroup.controls.rol.value"
                                        matSuffix mat-icon-button aria-label="Clear"
                                        (click)="secondFormGroup.controls?.rol.setValue('')">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </mat-form-field>
                                <button mat-raised-button color="primary" (click)="buscar_info_propiedad_rol()"
                                    [disabled]="!rol.valid">Buscar por Rol <i class="material-icons">search</i></button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="ccol-lg-12 col-md-12 col-sm--12 div_dir">
                                <p>Dirección</p>
                                <mat-form-field class="mat-field-calle">
                                    <input matInput type="text" placeholder="Calle" formControlName="dir"
                                        [matAutocomplete]="auto">
                                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete">
                                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                                            {{option}}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <button mat-button style="margin: 0px;" *ngIf="secondFormGroup.controls?.dir.value"
                                        matSuffix mat-icon-button aria-label="Clear"
                                        (click)="secondFormGroup.controls?.dir.setValue('')">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </mat-form-field>
                                <mat-form-field class="mat-field-calle">
                                    <input class="mat_input" matInput placeholder="Número" [formControl]="num">
                                    <button mat-button style="margin: 0px" *ngIf="secondFormGroup.controls?.num.value"
                                        matSuffix mat-icon-button aria-label="Clear"
                                        (click)="secondFormGroup.controls?.num.setValue('')">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </mat-form-field>


                                <button mat-raised-button color="primary" (click)="buscar_info_propiedad_direccion()"
                                    [disabled]="!num.valid || !dir.valid">Buscar por Dirección <i
                                        class="material-icons">search</i></button>
                            </div>
                        </div>
                        <div class="row" style="padding-top: 40px; padding-bottom: 30px;">
                            <div class="col-lg-12">
                                <table class="col-md-12" mat-table [dataSource]="lista_dir" class="mat-elevation-z8">
                                    <!--- Note that these columns can be defined in any order.
                                            The actual rendered columns are set as a property on the row definition" -->

                                    <!-- Position Column -->
                                    <ng-container matColumnDef="rol">
                                        <th mat-header-cell *matHeaderCellDef style="width: 30%"> <strong>Rol</strong>
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{element.rol}} </td>
                                    </ng-container>

                                    <!-- Name Column -->
                                    <ng-container matColumnDef="direccion">
                                        <th mat-header-cell *matHeaderCellDef style="width: 60%"><strong>Nombre</strong>
                                        </th>
                                        <td mat-cell *matCellDef="let element"> {{element.dirComp}}
                                        </td>
                                    </ng-container>

                                    <!-- Symbol Column -->
                                    <ng-container matColumnDef="actions">
                                        <th mat-header-cell *matHeaderCellDef style="width: 10%"><strong>Opción</strong>
                                        </th>
                                        <td mat-cell *matCellDef="let element; let i = index"><button mat-raised-button
                                                color="primary"
                                                (click)="eliminar_direccion(i ,element)">Eliminar</button></td>
                                    </ng-container>

                                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                </table>
                            </div>
                            <!-- <div class="col-lg-12 col-sm-12 col-xs-12 col-md-12" style="margin-top: 20px;">
                                <mat-form-field style="width: 100%;" appearance="fill">
                                    <mat-label>Observaciones</mat-label>
                                    <textarea [formControl]="observacion" matInput></textarea>
                                </mat-form-field>
                            </div> -->
                        </div>
                        <div class="row">
                            <div class="col-lg-6 col-md-6 col-sm-6" align="left">
                                <button class="btn_l" mat-raised-button color="primary"
                                    matStepperPrevious>Volver</button>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6" align="right">
                                <button class="btn_r" mat-raised-button color="primary" matStepperNext
                                    [disabled]="!segundoPaso">Continuar</button>
                            </div>
                        </div>
                    </form>
                </mat-step>





                <mat-step [stepControl]="secondFormGroup">
                    <ng-template matStepLabel>Selección</ng-template>
                    <div class="row">
                        <div class="col-lg-12" style="margin-left: 1%">
                            <strong>
                                <p class="title_datos">Seleccione los certificados que desee solicitar para cada
                                    propiedad</p>
                            </strong>
                        </div>
                    </div>
                    <div class="data" *ngFor="let item of dirs; let i = index">
                        <div class="row">
                            <div class="col-lg-12">
                                <p class="title_info">Rol {{ item.rol }}, {{ item.calle }} {{ item.num }}</p>
                            </div>
                        </div>
                        <div class="row checks" *ngFor="let certs of valores_cert; let o = index">
                            <div class="col-lg-12">
                                <mat-checkbox MatCheckboxChange class="example-margin" [value]="certs.alias"
                                    (change)="someFunction(i, o,item, $event)" [checked] #myCheckbox>
                                    {{ certs.nombre }}</mat-checkbox>
                                <mat-form-field style="margin-left: 10px;" class="example-full-width"
                                    *ngIf="certs.alias == 'ASIGM'">
                                    <!-- <mat-form-field style="margin-left: 10px;" class="example-full-width"
                                    *ngIf="certs.alias == 'ASIGM' && mostrarNum"> -->
                                    <mat-label>Cantidad de Números</mat-label>
                                    <input matInput placeholder="Num" (input)="someFunction(i, o,item, $event)"
                                        [(ngModel)]="numAsig[i]">
                                </mat-form-field>

                            </div>
                        </div>
                        <hr class="col-lg-12" />
                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6" align="left">
                            <button mat-raised-button color="primary" matStepperPrevious>Volver</button>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6" align="right">
                            <button mat-raised-button color="primary" matStepperNext [disabled]="!cert_seleccionado"
                                (click)="calcular_total()">Continuar</button>
                        </div>
                    </div>
                </mat-step>





                <mat-step [stepControl]="thirdFormGroup"
                    *ngIf="documentos_obligatorios[0] ||documentos_obligatorios[1] || documentos_obligatorios[2]">
                    <ng-template matStepLabel>Documentación</ng-template>



                    <div *ngFor="let item of dirs; let i = index">
                        <div *ngIf="documentos_obligatorios[i]">


                            <div class="row col-lg-12 col-md-12 col-sm-12">
                                <p class="title_info">{{ item.rol }}, {{ item.dirComp}}</p><br>
                            </div>

                            <div class="col-lg-3 col-md-3 col-sm-3 ">
                                <button mat-raised-button color="primary" (click)="adjuntar(item)">Adjuntar
                                    documentos</button>
                            </div>
                            <div class="col-lg-3 col-md-3 col-sm-3" style="padding-top: 2%;">

                                <!-- cambiar por direccion o rol -->
                                <div *ngIf="item.obligatorios_subidos">
                                    <img src="/assets/images/iconos/correct.png" style="width: 20px;">
                                    Archivos subidos
                                </div>

                                <div *ngIf="!item.obligatorios_subidos">
                                    <img src="/assets/images/iconos/war.png" style="width: 20px;"> No se han
                                    subido archivos.
                                </div>


                            </div>

                            <div class="row col-lg-12 col-md-12 col-sm-12">

                                <!-- <div *ngFor="let certificado of item.cert"> -->

                                <div class="row" style="padding: 0 4em 0 4em;">
                                    Documentos a Adjuntar: <i class="material-icons">description</i>Certificado de
                                    Avalúo Fiscal Detallado
                                </div>



                                <!-- </div> -->



                            </div>


                            <hr class="col-lg-12" />

                        </div>

                    </div>
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-6" align="left">
                            <button class="btn_l" mat-raised-button color="primary" matStepperPrevious>Volver</button>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6" align="right">
                            <button class="btn_r" mat-raised-button color="primary" matStepperNext
                                [disabled]="!obligatorios">Continuar</button>
                        </div>
                    </div>
                </mat-step>









                <mat-step>
                    <ng-template matStepLabel>Confirmación</ng-template>
                    <div class="container">
                        <div class="row">
                            <strong>
                                <p class="title_datos">Detalle lista de propiedades:</p>
                            </strong>
                        </div>
                        <div class="row" *ngFor="let item of certSelected; let i = index">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <p class="title_info">{{ item.rol }}, {{ item.calle}} Nº {{ item.num }}</p>
                            </div>
                            <div *ngFor="let cert of certSelected[i].certs; let o = index">
                                <div class="row cert_select_info" *ngIf="cert.selected">
                                    <div class="col-lg-5 col-md-5 col-sm-5">
                                        <p><i class="material-icons">description</i> {{ cert.nombre }}</p>
                                    </div>
                                    <div
                                        class="col-lg-1 col-md-1 col-sm-1 col-lg-offset-5 col-md-offset-5 col-sm-offset-5">
                                        <p>${{ cert.valor }} + estampilla (${{ cert.estampilla}})</p>
                                    </div>
                                </div>
                            </div>
                            <hr class="col-lg-12" />
                        </div>
                        <div class="row">
                            <div class="col-lg-12" *ngIf="primerPaso" style="padding-bottom: 20px;">
                                <strong>
                                    <p style="text-align: center;">Un comprobante de solicitud de pre ingreso le será
                                        enviado al
                                        siguiente
                                        correo electrónico:
                                        {{ info_rut.email }}</p>
                                </strong>
                            </div>
                            <div class="col-lg-12" *ngIf="mostrar_total2 > 0">
                                <strong>
                                    <p style="text-align: center;">El valor total a pagar es: ${{ mostrar_total2 }}</p>
                                </strong>
                            </div>
                        </div>
                        <div class="row">

                            <div class="row info_pagar">
                                <div class="col-lg-12 col-md-12 col-sm-12" style="padding-bottom: 20px">
                                    <p style="text-align: center;"> <b>Nota: </b>Las Certificaciones requieren de pago
                                        de Derechos Municipales a través del Portal de E-Com, una vez efectuado el pago
                                        se podrá realizar el ingreso definitivo de la solicitud y será notificado por
                                        correo electrónico.
                                    </p>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12" style="padding-bottom: 20px">
                                    <p style="text-align: center;"></p>

                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <p style="text-align: center;">
                                        Municipalidad de {{nombreMuni}} - Dirección de Obras
                                    </p>

                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <p style="text-align: center;">
                                        {{footer}}
                                    </p>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <p style="text-align: center;"><a href="webUrl" target="_blank"> {{web}}</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="col-lg-6 col-md-6 col-sm-6" align="left">
                            <button mat-raised-button color="primary" matStepperPrevious>Volver</button>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6" align="right">
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6" align="right">
                            <button mat-raised-button color="warn" (click)="onSubmit()"
                                [disabled]="pagando">Pagar</button>
                        </div>
                    </div>
                </mat-step>
            </mat-horizontal-stepper>
        </div>
    </div>
</body>


<!-- Material Dialog -->
<ng-template #ingreso_sol>
    <div class="ingreso_sol_title">
        <p>Ingresando nuevo solicitante</p>
    </div>
    <mat-dialog-content>
        <form [formGroup]="registro_sol">
            <div class="div_form_registrar">
                <mat-form-field>
                    <input matInput placeholder="Rut" type="text" formControlName="rut" disabled>
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Nombre" type="text" formControlName="nombre">
                    <button mat-button *ngIf="registro_sol.controls?.nombre" matSuffix mat-icon-button
                        aria-label="Clear" (click)="registro_sol.controls?.nombre.setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Ap. Paterno*" type="text" formControlName="app">
                    <button mat-button *ngIf="registro_sol.controls?.app" matSuffix mat-icon-button aria-label="Clear"
                        (click)="registro_sol.controls?.app.setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Ap. Materno*" type="text" formControlName="apm">
                    <button mat-button *ngIf="registro_sol.controls?.apm" matSuffix mat-icon-button aria-label="Clear"
                        (click)="registro_sol.controls?.apm.setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Calle*" type="text" formControlName="dir">
                    <button mat-button *ngIf="registro_sol.controls?.dir" matSuffix mat-icon-button aria-label="Clear"
                        (click)="registro_sol.controls?.dir.setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Número*" type="text" formControlName="num">
                    <button mat-button *ngIf="registro_sol.controls?.num" matSuffix mat-icon-button aria-label="Clear"
                        (click)="registro_sol.controls?.num.setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Dirección Complemento" type="text" formControlName="dircom">
                    <button mat-button *ngIf="registro_sol.controls?.dircom" matSuffix mat-icon-button
                        aria-label="Clear" (click)="registro_sol.controls?.dircom.setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Comuna*" type="text" formControlName="comuna">
                    <button mat-button *ngIf="registro_sol.controls?.comuna" matSuffix mat-icon-button
                        aria-label="Clear" (click)="registro_sol.controls?.comuna.setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Ciudad*" type="text" formControlName="ciudad">
                    <button mat-button *ngIf="registro_sol.controls?.ciudad" matSuffix mat-icon-button
                        aria-label="Clear" (click)="registro_sol.controls?.ciudad.setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Mail*" type="text" formControlName="email">
                    <button mat-button *ngIf="registro_sol.controls?.email" matSuffix mat-icon-button aria-label="Clear"
                        (click)="registro_sol.controls?.email.setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Fono" type="text" formControlName="telefono">
                    <button mat-button *ngIf="registro_sol.controls?.telefono" matSuffix mat-icon-button
                        aria-label="Clear" (click)="registro_sol.controls?.telefono.setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
                <mat-form-field>
                    <input matInput placeholder="Celular*" type="text" formControlName="celular">
                    <button mat-button *ngIf="registro_sol.controls?.celular" matSuffix mat-icon-button
                        aria-label="Clear" (click)="registro_sol.controls?.celular.setValue('')">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
        </form>
        <div class="btn_registrar">
            <button mat-raised-button color="primary" [disabled]="!registro_sol.valid"
                (click)="registrar_sol()">Registrar</button>
        </div>
    </mat-dialog-content>
</ng-template>
<!-- End Material Dialog -->



<ng-template #finalizarMSG>
    <h2 mat-dialog-title>Registro finalizado</h2>
    <mat-dialog-content>
        <p>Se realizó el ingreso de su solicitud.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="warn" id="cancel_mail" data-dismiss="modal"
            (click)="finalizarBTN()">Aceptar</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #direccionesDialog>
    <h2 style="color: tomato;" mat-dialog-title>Direcciones existentes en el rol</h2>
    <!-- <label id="example-radio-group-label">Seleccione una dirección:</label> -->
    <mat-dialog-content style="width: 400px;
    overflow: hidden auto;">
        <br>
        <div class="alert alert-info" role="alert">
            <i class="fa fa-info-circle" aria-hidden="true"></i>
            <strong> Debe seleccionar una de las direcciones</strong>
        </div>
        <div id="search-box-div" style="text-align: center; padding-bottom: 5px;">
            <div id="search-field" class="top-div">
                <input #input type="text" placeholder="Buscar" [(ngModel)]="searchText">
            </div>
        </div>
        <ul class="list-group">
            <li class="list-group-item"
                *ngFor="let dir of dirrecciones.dirs | filter: searchText | paginate: {itemsPerPage: 10, currentPage: p}">

                <input type="radio" id="direccionSelec" name="direccionSelect" [value]="dir" name="modal_dir"
                    [(ngModel)]="dirSeleccionada">
                <span style="margin-left: 4px;">{{dir.direcCompleta}}</span><span style="float: right;">{{ dir.rol
                    }}</span>
            </li>
        </ul>
        <div style="text-align:center">
            <pagination-controls [nextLabel]="'Siguiente'" [previousLabel]="'Anterior'" (pageChange)="p = $event">
            </pagination-controls>
        </div>
        <!-- <mat-radio-group aria-labelledby="example-radio-group-label" [(ngModel)]="dirSeleccionada"
            class="example-radio-group">
            <div class="row">
                <mat-radio-button class="example-radio-button" *ngFor="let dir of dirrecciones.dirs" [value]="dir">
                    {{ dir.direcCompleta }}
                </mat-radio-button>
            </div>
        </mat-radio-group> -->
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button matDialogClose mat-raised-button color="warn" id="clean_ingreso_propiet"
            data-dismiss="modal">Cancelar</button>
        <button mat-raised-button color="primary" id="ingreso_propiet" (click)="insertarDir()">Ingresar Propiedad <i
                class="fa fa-user-o" aria-hidden="true"></i></button>
    </mat-dialog-actions>
</ng-template>








<ng-template #modalDocumentos>
    <div align="right">
        <button mat-raised-button type="button" #closebutton color="primary" data-dismiss="modal"
            (click)="cerrarModal(); limpiarDocs(); this.dialog.closeAll()">Cerrar
            <i class="alert-circle " aria-hidden="true "></i></button>
    </div>


    <h2 mat-dialog-title align="center">Agregar Documentación</h2>
    <br>
    <!-- <p align="left" style="font-size: 18px;">Certificado: {{this.seleccion_nameCert}} </p> -->
    <p align="left" style="font-size: 18px;">ROL:
        {{this.seleccion_rol}}, {{this.seleccion_dire}} {{this.seleccion_num}} </p>


    <mat-dialog-content>
        <div class="row" *ngIf="!cargando">
            <div class="col-lg-12 col-md-12 col-sm--12 div_dir" style="margin-left: 1%">
                <p style="font-size: 17px">Para subir los archivos adjuntados
                    presione: <button mat-raised-button style="background-color: rgb(234, 155, 65);"
                        (click)="uploadAllfiles();" [disabled]="!(files.length > 0 && pase == true)">Subir
                        los
                        archivos</button></p>
            </div>
        </div>
        <div class="row">

            <div class="col-lg-12 " style="margin-left: 1%">
                <fieldset id="archivos" class="archivos">
                    <div>
                        <div class="col-md-12" align="center" id="content">

                            <div class="datatable_adjuntos" *ngIf="cargando">
                                Se están cargando los documentos obligatorios para este ingreso, espere un
                                momento...
                                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                            </div>
                            <div class="datatable_adjuntos" *ngIf="!cargando">
                                <ngx-datatable class="material" [columnMode]="'flex'" [headerHeight]="50"
                                    [footerHeight]="50" rowHeight="auto" [rows]="rowsObligatorios"
                                    style="width: 100%; text-align: left;">

                                    <ngx-datatable-column [flexGrow]="2">
                                        <ng-template ngx-datatable-header-template>
                                            <span>Nombre Documento</span>
                                        </ng-template>
                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                            {{row.name}}
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column [flexGrow]="2">
                                        <ng-template ngx-datatable-header-template>
                                            <span>Nombre Archivo</span>
                                        </ng-template>
                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                            {{row.archivo}}
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column [flexGrow]="1">
                                        <ng-template ngx-datatable-header-template>
                                            <span>Peso</span>
                                        </ng-template>
                                        <ng-template let-row="row" ngx-datatable-cell-template>
                                            {{row.peso}}
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-column [flexGrow]="2">
                                        <ng-template ngx-datatable-header-template>
                                            <span>Opciones</span>
                                        </ng-template>

                                        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>

                                            <div style="display: flex;">
                                                <button mat-raised-button (click)="file.click()"
                                                    style="cursor: pointer;">
                                                    <mat-icon matSuffix>attach_file</mat-icon>
                                                    Adjuntar
                                                </button>
                                                <span *ngIf="row.newAttached" style="padding-top: 10%;"><i
                                                        class="glyphicon glyphicon-trash" (click)="deleteFile2(row)"
                                                        style="cursor: pointer; padding-left: 15%;"></i></span>
                                            </div>
                                            <input type="file" #file
                                                (change)="handleFileInput2($event.target.files, row)"
                                                style="display:none;"
                                                accept=".jpg,.png,.DWG,.dwg,.pdf,.docx,.doc,.xls,.xlsx">
                                        </ng-template>
                                    </ngx-datatable-column>
                                    <ngx-datatable-footer>

                                        <ng-template ngx-datatable-footer-template let-rowCount="rowCount"
                                            let-Size="actualSizeFiles" let-selectedCount="selectedCount"
                                            let-curPage="curPage" let-offset="offset">
                                            <div style="padding: 5px 10px">

                                                <div class="col-md-4" align="left" *ngIf="false">
                                                    <button mat-raised-button color="primary"
                                                        style="padding-top: 5px;margin-bottom: 2rem;"
                                                        id="ingreso_documentos"
                                                        (click)="openAdjuntosModal(); nombreArchivo = ''">
                                                        <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                                        Agregar nuevo
                                                        documento
                                                    </button>
                                                </div>

                                            </div>
                                        </ng-template>
                                    </ngx-datatable-footer>
                                </ngx-datatable>
                            </div>
                        </div>


                    </div>

                </fieldset>
            </div>
        </div>


    </mat-dialog-content>

</ng-template>


<ng-template #confirmarNuevosArchivos>
    <h2 mat-dialog-title>Usted ya ingreso archivos para este certificado.</h2>
    <mat-dialog-content>
        <p>Si desea volver a subir nuevos archivos, presione "Continuar", si quiere mantener los archivos subidos
            anteriormente presione "Cancelar".</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button matDialogClose mat-raised-button color="primary" id="cancel_mail" data-dismiss="modal"
            (click)="limpiarDocs(); this.dialog.closeAll()">Cancelar</button>
        <button matDialogClose mat-raised-button color="warn" id="cancel_mail" data-dismiss="modal"
            (click)="confirmarAdjuntarNuevos()">Continuar</button>
    </mat-dialog-actions>
</ng-template>